import { UtilitiesService } from "../utilities.service";
import { RolesUser } from "../../enum/roles-user.enum";
import { Roles } from "../../models/roles/roles.enum";
import { Injectable, OnDestroy } from "@angular/core";
import { AutoUnsubscribe } from "ngx-auto-unsubscribe";

@AutoUnsubscribe()
@Injectable()
export class RealtimeCommonService implements OnDestroy {

    ngOnDestroy() {
      
    }

    constructor(private utilitiesService: UtilitiesService){}
    
    private role: any = null;
    /**
     * Recupera o token real para conexão com o backend (caso o usuário identificado tenha 
     * sido marcado como delay a sessio Id deve ser extraída do jwt)
     */
    normalizeToken(token: string, role: any = null){
        
        if(this.utilitiesService.isValidJwtToken(token) && this.checkIfIsActiveOrRegistred(role)){
            return token;
        }

        if(this.utilitiesService.isValidJwtToken(token) && !this.checkIfIsActiveOrRegistred(role))
            return this.utilitiesService.extractJwtKeyValue(token, 'SessionID');

        return token;
    }

    /** Verifica se o usuário é ativo ou cadastrado (apenas usuários ativos ou cadatrados têm acesso as informações sem delay)
     * @param profile perfil do usuário (role) 
     * @return booleano se ativou ou registrado
     * */
    
    checkIfIsActiveOrRegistred(profile: string | number): boolean {
        switch(profile) {
            case RolesUser.Activated:
            case RolesUser.Registered:
            case Roles.Activated:
            case Roles.Registered:
                return true;
            default:
                return false;
        }
    }

     /**
     * Verifica se o usuário pode usar realtime ou delay
     * @param token token (session id ou jwt)
     */
    canUseRealTimeVersion(token: string, role: any):boolean{
        
        let authenticated = this.utilitiesService.isValidJwtToken(token) && this.checkIfIsActiveOrRegistred(role);
        
        //usuário apenas identificado
        if(this.utilitiesService.isValidJwtToken(token) && !this.checkIfIsActiveOrRegistred(role)){
            authenticated = false;
        }

        return authenticated;
    }


}
    /** Modelo para gerenciar inscrições em um proxy */
export class SubscribersInfo{

    constructor( public topics = []){
       
    }

    get total():number{
        return this.topics.length;
    }
    
    public getSubscribersAmount(topic: string = null){
        return topic ? this.topics.filter(t => t.match( new RegExp(topic, 'i'))).length : this.total;
    }

    public removeOneSubscriber(topic: string = null){

        if(topic == null){
            if(this.topics.length > 0)
                this.topics.splice(0,1);

            return this.topics.length;
        }

        const index = this.topics.findIndex(t => t.match( new RegExp(topic, 'i')));

        if(index >= 0) {
            this.topics.splice(index, 1);
        }

        return this.topics.length;
    }

    public registerSubscriber(topic: string = null){
        this.topics.push(topic ? topic.toUpperCase() : null);
    }

    public registerSubscribers(topics: Array<string>) {
        this.topics = this.topics.concat(topics.filter(i => i).map(t => t.toUpperCase()));
    }

    public hasSubscriber(topic: string = null){
        return this.getSubscribersAmount(topic) >= 1;
    }

    reset():void{
        this.topics = [];
    }
}
